import { Layers, GitBranch, Cpu, BarChart3 } from "lucide-react";
import ProductPage from "@/components/ProductPage";
import {
  useDocumentTitle,
  DEFAULT_STEPS,
} from "@/lib/shared";

const FEATURES = [
  {
    Icon: Layers,
    title: "Omnicanalidad Nativa",
    desc: "Los agentes gestionan interacciones de voz y canales digitales (chat, correo) simultáneamente desde la misma interfaz, integrando en vivo los datos de tu CRM.",
  },
  {
    Icon: GitBranch,
    title: "Enrutamiento por Habilidades",
    desc: "Las interacciones se enrutan automáticamente al agente con el conjunto de habilidades más adecuado para resolver el problema rápidamente.",
  },
  {
    Icon: Cpu,
    title: "IA Conversacional Integrada",
    desc: "Diseño AI-first que automatiza el IVR y brinda autoservicio inteligente desde el primer contacto.",
  },
  {
    Icon: BarChart3,
    title: "Control y Reportes",
    desc: "Tableros de control en tiempo real para que los supervisores midan y optimicen el rendimiento de las campañas al instante.",
  },
];

const ContactCenterPage = () => {
  useDocumentTitle("Caruna Contact Center — Atención Omnicanal con IA");
  return (
    <ProductPage
      category="contact-center"
      eyebrow="CONTACT CENTER OMNICANAL"
      headline="Convierte Microsoft Teams en un Contact Center Omnicanal y potenciado por IA."
      subhead="Transforma tu operación de atención al cliente sin integraciones complejas ni cambiar de ventana. Nuestra plataforma certificada para Teams (basada en Voca CIC) ofrece una experiencia de pantalla única para tus agentes."
      features={FEATURES}
      steps={DEFAULT_STEPS}
      integrations={["Microsoft Teams"]}
      ctaHeadline="Solicita una evaluación técnica de Contact Center"
      featuresNote="Teléfonos y Salas MTR — Flexibilidad de adquisición CAPEX u OPEX según tus necesidades."
      productName="Caruna Contact Center"
      baseTech="Voca CIC"
      heroBody="Caruna Contact Center convierte Microsoft Teams en un contact center omnicanal certificado: los agentes gestionan voz, chat y correo desde una sola interfaz integrada con tu CRM, con enrutamiento por habilidades, IA conversacional y tableros de control en tiempo real."
    />
  );
};

export default ContactCenterPage;
